

import { BidiModule } from '@angular/cdk/bidi';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MwcNoAnimationModule } from 'mwc/core/no-animation';
import { MwcOutletModule } from 'mwc/core/outlet';
import { MwcOverlayModule } from 'mwc/core/overlay';

// NOTE: the `t` is not uppercase in directives. Change this would however introduce breaking change.
import { MwcToolTipComponent, MwcTooltipDirective } from './tooltip';

@NgModule({
  declarations: [MwcToolTipComponent, MwcTooltipDirective],
  exports: [MwcToolTipComponent, MwcTooltipDirective],
  imports: [BidiModule, CommonModule, OverlayModule, MwcOutletModule, MwcOverlayModule, MwcNoAnimationModule]
})
export class MwcToolTipModule {}
